import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import {
  alignSelf,
  height,
  space,
  width,
  type HeightProps,
  type WidthProps
} from 'styled-system';

import arrowInCircle from './arrow-in-circle';
import cross from '../images/svg/cross.svg';
import crossRedCircle from '../images/svg/cross-red-circle.svg';
import play from '../images/svg/play.svg';
import playCircle from '../images/svg/play-circle.svg';
import chevronRight from '../images/svg/chevron-right.svg';
import chevronRight2 from '../images/svg/chevron-right-2.svg';
import lead from '../images/svg/lead-icon.svg';
import magnify from '../images/svg/magnify.svg';
import minusInCircle from '../images/svg/minus-in-circle.svg';
import tickInCircle from '../images/svg/tick-in-circle.svg';
import tickGreenCircle from '../images/svg/tick-green-circle.svg';
import zoom from '../images/svg/zoom.svg';
import { getThemeColor } from '../utils/styles';
import mq from '../utils/mq';

const getFillColor = ({
  fillColor,
  ...props
}: {
  fillColor?: string | string[];
  [key: string]: any;
}) => {
  if (typeof fillColor === 'string') {
    return css`
      path {
        fill: ${getThemeColor(fillColor)(props)};
      }
    `;
  } else if (Array.isArray(fillColor)) {
    return css`
      path {
        ${fillColor[2] &&
        css`
          fill: ${getThemeColor(fillColor[2])(props)};
        `}

        ${fillColor[1] &&
        mq.tablet(css`
          fill: ${getThemeColor(fillColor[1])(props)};
        `)}

        ${fillColor[0] &&
        mq.mobile(css`
          fill: ${getThemeColor(fillColor[0])(props)};
        `)}
      }
    `;
  }
};

export type IconName = keyof typeof ICONS;

const ICONS = {
  arrowInCircle,
  cross,
  crossRedCircle,
  play,
  playCircle,
  chevronRight,
  chevronRight2,
  chevronLeft2: chevronRight2,
  lead,
  magnify,
  minusInCircle,
  tickInCircle,
  tickGreenCircle,
  zoom
};

export interface IconProps extends WidthProps, HeightProps {
  name: IconName;
  fillColor?: string;
  strokeColor?: string;
}

const IconSVG: FC<IconProps> = (props) => {
  const SVG = ICONS[props.name];

  return <SVG {...props} />;
};

const Icon = styled(IconSVG)`
  ${space}
  ${height}
  ${width}
  ${getFillColor}
  ${alignSelf}

  ${(props) =>
    props.strokeColor &&
    props.name !== 'playCircle' &&
    css`
      stroke: ${getThemeColor(props.strokeColor)(props)};
    `}

  ${({ name }) =>
    name === 'chevronLeft2' &&
    css`
      transform: rotate(180deg) translateX(2px);
    `}
`;

export default Icon;
